import constants from '@/services/constants'

const defaultPagination = {
    page: 1,
    sortBy: null,
    sortType: null,
    itemsPerPage: constants.ITEM_PER_PAGE,
    totalVisible: constants.MAX_PAGE_VISIBLE
}

export default {
    data () {
        return {
            ...defaultPagination
        }
    },

    computed: {
        pagination () {
            return {
                itemsPerPage: this.itemsPerPage
            }
        },

        showPagination () {
            return this.pageTotal > 1
        },

        total () {
            return 0
        },

        pageTotal () {
            return Math.ceil(this.total / this.itemsPerPage)
        }
    },

    methods: {
        getDefaultPagination () {
            return defaultPagination
        },

        getQueryObject () {
            return {
                page: this.page,
                itemsPerPage: this.itemsPerPage,
                sortBy: this.sortBy,
                sortType: this.sortType
            }
        },

        onPaginationChanged (value) {
            this.page = value
        },

        resetPagination () {
            this.page = defaultPagination.page
            this.sortBy = defaultPagination.sortBy
            this.sortType = defaultPagination.sortType
            this.itemsPerPage = defaultPagination.itemsPerPage
            this.totalVisible = defaultPagination.totalVisible
        }
    }
}
